module.exports = __webpack_public_path__ + "media/images/logo-white-3b20e513fb93aea889726798294d1e8e.png";